import React from "react";
import styles from "./ContentBlock.module.scss";
import classNames from "classnames/bind";
import Button from "../ui/Button/Button";
const cx = classNames.bind(styles);

function ContentBlock({
  contentSide = "left",
  theme = "light",
  title,
  buttonProps = {},
  textbtn,
  srcImage,
  imageAlt,
  imageFit = "cover",
  description,
  direction = "vertical",
  mobileContentLayout = "title_top_button_bottom",
}) {
  return (
    <div className={cx("container-content", contentSide, theme, `mobile-${mobileContentLayout}`)}>
      <div className={cx("body-content")}>
        <div className={cx("body")}>
          <p className={cx("content-tittle")}>{title}</p>
          {description && (
            <div className={cx("content-main")}>
              {description.split("\n").map((line, index) => (
                <p key={index}>
                  {line}

                </p>
              ))}
            </div>
          )}
          {textbtn && (
            <div className={cx("body-button")}>
              <Button content={textbtn} {...buttonProps} className={cx("btn")} />
            </div>
          )}
        </div>
      </div>
      <div className={cx("image", { "direction": direction === "direction" })}>
        <img src={srcImage} alt={imageAlt || title} loading="lazy" style={{ objectFit: imageFit }} />
      </div>
    </div>
  );
}

export default ContentBlock;
